const mobileBottomNav = [
  {
    name: "Focus Zone",
    path: "/focusZone",
    image: "/assets/svg/tabbar/focus.svg",
    selectedImage: "/assets/svg/tabbar/selectedFocus.svg",
  },
  {
    name: "Tracks",
    path: "/tracks",
    image: "/assets/svg/tabbar/tracks.svg",
    selectedImage: "/assets/svg/tabbar/selectedTracks.svg",
  },

  {
    name: "Add Goal",
    image: "/assets/svg/tabbar/addFromTabbar.svg",
    selectedImage: "/assets/svg/tabbar/addFromTabbar.svg",
  },
  {
    name: "Goal Hub",
    path: "/goalHub",
    image: "/assets/svg/tabbar/goalHub.svg",
    selectedImage: "/assets/svg/tabbar/selectedGoalHub.svg",
  },
  {
    name: "Journal",
    path: "/journal",
    image: "/assets/svg/tabbar/journal.svg",
    selectedImage: "/assets/svg/tabbar/selectedJournal.svg",
  },
];
export { mobileBottomNav };
